module.exports = __webpack_public_path__ + "static/media/img-home4.bd80b80e.jpg";